import { useState } from 'react';
import Modal from '../../../../components/modal/Modal';
import { BUTTON_CONSTANTS, MARKETPLACE_LISTING_CONSTANTS } from '../../../../constants/common';
import type { MarketplaceListingRow } from '../Listing';
import './removeListingModal.scss';

export type RemoveListingModalProps = {
  isOpen: boolean;
  width?: number;
  setIsOpen: (open: boolean) => void;
  listing: MarketplaceListingRow | null;
  onClose?: () => void;
  onConfirm: (listing: MarketplaceListingRow, reason: string) => void;
};

const RemoveListingModal = ({ isOpen, width = 480, setIsOpen, listing, onClose, onConfirm }: RemoveListingModalProps) => {
  const [reason, setReason] = useState('');

  const handleClose = () => {
    setReason('');
    onClose?.();
    setIsOpen(false);
  };

  const handleConfirm = () => {
    if (listing) {
      const trimmedReason = reason.trim();
      if (trimmedReason) {
        onConfirm(listing, trimmedReason);
        setReason('');
        setIsOpen(false);
      }
    }
  };

  const isConfirmDisabled = !listing || !reason.trim();

  return (
    <Modal isOpen={isOpen} onClose={handleClose} width={width} ignoreBackdrop>
      <div className="remove-listing-modal">
        <div className="header">
          <h4>{MARKETPLACE_LISTING_CONSTANTS.REMOVE_LISTING_HEADER}</h4>
        </div>
        <div className="body">
          <p>{MARKETPLACE_LISTING_CONSTANTS.REMOVE_LISTING_DESCRIPTION}</p>
          <div className="remove-listing-modal__reason">
            <label htmlFor="remove-listing-reason">
              <span className="remove-listing-modal__required">*</span>
              {MARKETPLACE_LISTING_CONSTANTS.REASON_FOR_REMOVAL_LABEL}
            </label>
            <textarea
              id="remove-listing-reason"
              value={reason}
              onChange={e => setReason(e.target.value)}
              placeholder={MARKETPLACE_LISTING_CONSTANTS.REASON_FOR_REMOVAL_PLACEHOLDER}
              rows={4}
              cols={50}
            />
          </div>
        </div>
        <div className="footer">
          <button type="button" className="button red inverted small" onClick={handleClose}>
            {BUTTON_CONSTANTS.CANCEL}
          </button>
          <button type="button" className="button green" onClick={handleConfirm} disabled={isConfirmDisabled}>
            {BUTTON_CONSTANTS.CONFIRM}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default RemoveListingModal;
